import { render } from "./QuantitativeForm.vue?vue&type=template&id=797546fa&ts=true"
import script from "./QuantitativeForm.vue?vue&type=script&lang=ts"
export * from "./QuantitativeForm.vue?vue&type=script&lang=ts"

import "./QuantitativeForm.vue?vue&type=style&index=0&id=797546fa&lang=css"

import exportComponent from "C:\\wamp64\\www\\hayllissac\\sistema\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__